
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"app-eed_svg__a"}},[_c('path',{attrs:{"fill":"#fff","d":"M4 12a1 1 0 011-1h3a1 1 0 011 1v5H4z"}})])]),_c('g',{staticClass:"icon-stroke",attrs:{"fill":"none","stroke":"#fff","stroke-miterlimit":"50"}},[_c('path',{attrs:{"d":"M2.5 16.594a1 1 0 01-1-1V6.931a1 1 0 01.293-.707L6.31 1.707a1 1 0 011.414 0l4.517 4.517a1 1 0 01.293.707v8.663a1 1 0 01-1 1z"}}),_c('path',{attrs:{"stroke-width":"2","d":"M4 12a1 1 0 011-1h3a1 1 0 011 1v5H4v0z","clip-path":"url(#app-eed_svg__a)","transform":"translate(.5)"}})])])
          )
        }
      }
    